import { Button, IconButton, Image } from "@chakra-ui/react";
import React from "react";

import {
  RiAddCircleLine,
  RiDeleteBinLine,
  RiDownloadLine,
} from "react-icons/ri";
import { useColorMode } from "./ui/color-mode";

const ButtonComp = (props) => {
  // const deleteIconColor = useColorModeValue("#4c4c4c", "#f56565"); // dark gray in light mode, red in dark mode
  const { colorMode } = useColorMode();
  const isDarkmode = colorMode === "dark";

  const cProps = {
    // fontSize: "1rem",
    // borderRadius: "10px",
    ...props,
    disabled: props?.disabled ?? false,
  };

  if (
    props?.keyname === "submit" ||
    props?.keyname === "save" ||
    props?.keyname === "add" ||
    props?.keyname === "next" ||
    props?.keyname === "lookup" ||
    props?.keyname === "sendemail"
  ) {
    // cProps.w = "12rem";
    cProps.bg = "button.solid";
    cProps.color = "textlite";
    // } else if (props?.keyname === "next") {
    cProps.w = "8rem";
    // cProps.bg = "ext";
    // cProps.variant = "outline";
  } else if (props?.keyname === "prev") {
    // cProps.w = "8rem";
    // cProps.bg = "fontdark";
    cProps.variant = "outline";
  } else if (props.keyname === "clear") {
    cProps.variant = "ghost";
  } else if (props?.keyname === "download-ic") {
    return <RiDownloadLine {...cProps} size={"2rem"} color="#4c4c4c" />;
  } else if (props?.keyname === "delete-ic") {
    return <RiDeleteBinLine {...cProps} size={"2rem"} color="#4c4c4c" />;
  } else if (props?.keyname === "delete-ic-2") {
    if (isDarkmode) {
      return (
        <IconButton {...cProps} aria-label="delete" variant={"ghost"}>
          <Image
            cursor="pointer"
            w={"2rem"}
            h={"2rem"}
            objectFit={"contain"}
            aspectRatio={"square"}
            src="/img/img-ic-delete-lite.png"
          />
        </IconButton>
      );
    } else {
      return (
        <IconButton {...cProps} aria-label="delete" variant={"ghost"}>
          <Image
            cursor="pointer"
            w={"2rem"}
            h={"2rem"}
            objectFit={"contain"}
            aspectRatio={"square"}
            src="/img/img-ic-delete.png"
          />
        </IconButton>
      );
    }
  } else if (props?.keyname === "upload-ic") {
    return <RiAddCircleLine {...cProps} size={"2rem"} color="#4c4c4c" />;
    // return (
    //   <IconButton variant={"plain"} {...cProps}>
    //     <IoIosAddCircleOutline />
    //   </IconButton>
    // );
  } else if (props?.keyname === "manage-item-btn") {
    cProps.bg = "button.solid2";
    cProps.color = "button.outline";
  }
  if (props?.keyname === "home-card-br") {
    cProps.bg = cProps.bg || "buttonblue";
    // cProps.bg = "button.solid";
    cProps.color = "textlite";
    // cProps.fontSize = '0.8rem';
    cProps.h = "2rem";
    cProps.p = "0.8rem";
  }
  if (props?.keyname === "header-menu") {
    cProps.bg = "button.solid";
    cProps.color = "textlite";
  } else {
    cProps.variant = "outline";
  }

  return <Button {...cProps}>{props?.label}</Button>;
};

export default ButtonComp;
